<script setup lang="ts">
  import type { HTMLAttributes } from "vue";
  import { RadioGroupItem } from "reka-ui";
  import { cn } from "@/lib/utils";

  interface Props {
    value: string;
    label?: string;
    description?: string;
    disabled?: boolean;
    class?: HTMLAttributes["class"];
  }

  const props = withDefaults(defineProps<Props>(), {
    label: "",
    description: "",
    disabled: false,
    class: undefined,
  });

  const itemId = `radio-card-${props.value}`;
</script>

<template>
  <div class="relative h-full">
    <RadioGroupItem
      :id="itemId"
      :value="props.value"
      :disabled="props.disabled"
      class="peer sr-only" />
    <label
      :for="itemId"
      :class="
        cn(
          'flex h-full flex-col rounded-md border-2 border-muted bg-popover p-3 cursor-pointer transition-all',
          'hover:bg-accent hover:text-accent-foreground',
          'peer-data-[state=checked]:border-primary',
          'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
          props.class,
        )
      ">
      <div class="size-5 mb-2.5 text-muted-foreground [&>svg]:size-5 [&>img]:size-5">
        <slot name="icon" />
      </div>
      <span
        v-if="props.label"
        class="text-sm font-medium tracking-tight">
        {{ props.label }}
      </span>
      <p
        v-if="props.description"
        class="text-xs text-muted-foreground">
        {{ props.description }}
      </p>
      <slot />
    </label>
  </div>
</template>
